export default __webpack_public_path__ + "static/media/4.b2abe910.png";